import './AppRe.css';
import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Imagens from '../../img/imagens';

export default function ReservaSala() {
    // Carregar APIs
    const baseUrl = "http://10.80.12.5:81/api"; // API de Produção
    //const baseUrl = "https://localhost:44304/api"; // API de DEV (localhost)


    // Carregar States
    const [dataRes, setDataRes] = useState([]); // Reservas
    const [updateData, setUpdateData] = useState(true); // Controle de atualização
    const [modalReservaAberto, setModalReservaAberto] = useState(false); // Modal de reserva
    const dataAtual = new Date().toLocaleDateString(); // Data atual
    const [salas, setSalas] = useState([]); // Lista de salas
    const [salasStatus, setSalasStatus] = useState([]); // Status das salas
    const [atualizarReservas, setAtualizarReservas] = useState(false); // Controle de atualização de reservas
    const [isLoading, setIsLoading] = useState(false); // Estado de loading


    // Estado para reserva selecionada
    const [reservaSelecionada, setReservaSelecionada] = useState({
        reservaId: '',
        horaInicio: '',
        horarioFinal: '',
        dataReserva: '',
        colaboradorNome: '',
        salaId: '',
    });

    // Função para resetar o formulário e fechar modal
    const atualizarPagina = () => {
        setModalReservaAberto(false);
        setReservaSelecionada({
            reservaId: '',
            horaInicio: '',
            horarioFinal: '',
            dataReserva: '',
            colaboradorNome: '',
            salaId: '',
        });
    };

    // Headers padrão para requisições
    const headers = {
        'Content-Type': 'application/json'
    };

    // GET - Busca status das salas
    const buscarStatusSalas = async () => {
        try {
            const response = await axios.get(`${baseUrl}/Sala`);
            //console.log("🧱 Salas recebidas:", response.data); // <-- Aqui
            setSalasStatus(response.data);
        } catch (error) {
            console.error("Erro ao buscar status das salas:", error);
        }
    };

    // GET - Busca reservas
    const ReservaGet = async () => {
        try {
            const response = await axios.get(`${baseUrl}/Reserva`);
            if (response.data) {
                setDataRes(response.data);

            } else {
                setDataRes([]); // evita travar visual
                console.log("A resposta da solicitação GET está vazia.");
            }
        } catch (error) {
            console.error("Erro ao fazer solicitação GET:", error);
            setDataRes([]); // também aqui, só por segurança
        }
    };

    // POST - Cria nova reserva
    const ReservaPost = async () => {
        setIsLoading(true);
        try {
            const novaReserva = {
                ...reservaSelecionada,
                salaId: parseInt(reservaSelecionada.salaId),
                dataReserva: new Date(reservaSelecionada.dataReserva).toISOString().split('T')[0]
            };

            delete novaReserva.reservaId;

            const response = await axios.post(`${baseUrl}/Reserva`, novaReserva, { headers });
            console.log("novaReserva enviado:", JSON.stringify(novaReserva, null, 2));
            await axios.post(`${baseUrl}/EmailReserva/send`, novaReserva, { headers });

            setDataRes(prev => [...prev, response.data]);
            setAtualizarReservas(true);
            setReservaSelecionada({
                reservaId: '',
                horaInicio: '',
                horarioFinal: '',
                dataReserva: '',
                colaboradorNome: '',
                salaId: '',
            });
            fecharModal(); // Fechar modal apenas após o sucesso
        } catch (error) {
            if (error.response?.status === 400) {
                alert('Já existe uma reserva para este horário.');
            } else {
                console.error("Erro ao criar reserva ou enviar e-mail:", error);
            }
        } finally {
            setIsLoading(false);
        }
    };

    // Carrega dados iniciais e atualiza quando necessário
    const carregarDados = async () => {
        if (updateData) {
            await Promise.all([
                ReservaGet(),
                buscarStatusSalas(),
            ]);
            setUpdateData(false);
        } else if (!modalReservaAberto || atualizarReservas) {
            await ReservaGet();
            setAtualizarReservas(false);
            //setUpdateData(true);
        }
    };

    // useEffect para carregar dados ao montar e quando dependências mudam
    useEffect(() => {
        carregarDados();
    }, [updateData, modalReservaAberto, atualizarReservas]);


    // Manipula mudanças nos campos do formulário de reserva
    const handleChangeRes = e => {
        const { name, value } = e.target;
        setReservaSelecionada(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Abre modal de nova reserva
    const abrirModal = async () => {
        await buscarStatusSalas(); // Busca os status atualizados
        setModalReservaAberto(true);
    };
    // Fecha modal de nova reserva
    const fecharModal = async () => {
        setModalReservaAberto(false);
        setReservaSelecionada({
            reservaId: '',
            horaInicio: '',
            horarioFinal: '',
            dataReserva: '',
            colaboradorNome: '',
            salaId: '',
        });


    };

    // Estados e funções para modal de exclusão
    const [modalExcluirAberto, setModalExcluirAberto] = useState(false);
    const [reservaParaExcluir, setReservaParaExcluir] = useState(null);
    const [motivoExclusao, setMotivoExclusao] = useState('');
    const [emailSolicitante, setEmailSolicitante] = useState('');

    // Abre modal de exclusão
    const abrirModalExcluir = (reserva) => {
        setReservaParaExcluir(reserva);
        setMotivoExclusao('');
        setEmailSolicitante('');
        setModalExcluirAberto(true);
    };

    // Fecha modal de exclusão
    const fecharModalExcluir = () => setModalExcluirAberto(false);

    // Solicita exclusão de reserva
    const solicitarExclusao = async () => {
        if (!motivoExclusao || !emailSolicitante) {
            alert("Por favor, preencha todos os campos.");
            return;
        }

        // Validação da data
        const dataReserva = reservaParaExcluir?.dataReserva;
        

        if (!dataReserva) {
            alert("Data da reserva não definida.");
            return;
        }

        const dataObj = new Date(dataReserva.split('/').reverse().join('-'));

        if (isNaN(dataObj.getTime())) {
            alert("Data da reserva inválida.");
            return;
        }

        const payload = {
            reserva: {
                ...reservaParaExcluir,
                dataReserva: dataObj.toISOString().split('T')[0], // Formato YYYY-MM-DD
            },
            motivo: motivoExclusao,
            emailSolicitante: emailSolicitante
        };

        console.log("Payload enviado:", JSON.stringify(payload, null, 2));

        try {
            await axios.post(`${baseUrl}/EmailReserva/solicitar-exclusao`, payload, { headers });
            alert("Solicitação de exclusão enviada com sucesso.");
            fecharModalExcluir();
        } catch (error) {
            console.error("Erro ao solicitar exclusão:", error);
            alert("Erro ao solicitar exclusão.");
        }
    };

    // Função para converter data do formato brasileiro para Date
    function parseDataBrasil(dataStr) {
        const [dia, mes, ano] = dataStr.split('/');
        return new Date(ano, mes - 1, dia);
    }

    // Verifica se a reserva é futura
    function isReservaFutura(reserva) {
        const hoje = new Date().setHours(0, 0, 0, 0);
        const dataReserva = parseDataBrasil(reserva.dataReserva).setHours(0, 0, 0, 0);
        return dataReserva >= hoje;
    }

    // Ordena reservas por data e hora
    function ordenarReservas(a, b) {
        const dataA = new Date(a.dataReserva).setHours(0, 0, 0, 0);
        const dataB = new Date(b.dataReserva).setHours(0, 0, 0, 0);

        if (dataA !== dataB) return dataA - dataB;
        return a.horaInicio.localeCompare(b.horaInicio);
    }

    // Filtra e ordena reservas recentes por sala
    function getReservasRecentesPorSala(dataRes, salaId) {
        const reservasFiltradas = dataRes.filter(reserva => reserva.salaId === salaId && isReservaFutura(reserva));
        const reservasOrdenadas = reservasFiltradas.sort(ordenarReservas);
        return reservasOrdenadas.slice(0, 6);
    }

    // Renderização do componente principal
    return (
        <div className="App">
            <header className="App-header">
                <a href='https://www.prefeitura.sp.gov.br/cidade/secretarias/controladoria_geral/' target='blank' rel="noopener noreferrer" className='logolink'>
                    <img src={Imagens.CGM1} alt="Prefeitura" width="150" className='logo' />
                </a>
                <div className='Voltar'>
                    <Link className='voltarbtn' to="/">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" className="bi bi-arrow-return-left" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5" />
                        </svg>
                        <p> &nbsp; Voltar a tela inicial</p>
                    </Link>
                </div>
            </header>

            <div className='ReservaSala'>
                <div className="containerReserva">
                    <div className='row align-items-center mb-4'>
                        <div className='col-md-8'>
                            <h2 className='TituloReserva'>Reservas de Salas a partir de {dataAtual}</h2>
                        </div>
                        <div className='col-md-4 text-md-end'>
                            <Button color="success" onClick={abrirModal}>+ Nova Reserva</Button>
                        </div>
                    </div>

                    {salasStatus.map(bloco => (
                        <div className="row mb-5" key={bloco.salaId}>
                            <div className="col-md-6">
                                <h3 className='salatitulo'>Sala de Reunião - {bloco.nomeSala}</h3>
                            </div>
                            <div className="col-md-6">
                                <table className="table table-bordered table-striped">
                                    <thead className="table-light">
                                        <tr>
                                            <th colSpan={5}>Horários Reservados</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getReservasRecentesPorSala(dataRes, bloco.salaId).map(reserva => (
                                            <tr key={reserva.reservaId}>
                                                <td>{reserva.dataReserva}</td>
                                                <td>{reserva.horaInicio}</td>
                                                <td>{reserva.horarioFinal}</td>
                                                <td>{reserva.colaboradorNome}</td>
                                                <td>
                                                    <Button color="danger" size="sm" onClick={() => abrirModalExcluir(reserva)}>
                                                        Solicitar Exclusão
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal de Nova Reserva - Atualizado */}
            <Modal isOpen={modalReservaAberto} toggle={fecharModal}>
                <ModalHeader toggle={fecharModal}>Nova Reserva</ModalHeader>
                <ModalBody>
                    <div className="mb-3">
                        <label className="form-label">Setor - Colaborador</label>
                        <input placeholder="Informe o setor e o responsável que está agendando "
                            type="text"
                            className="form-control"
                            name="colaboradorNome"
                            value={reservaSelecionada.colaboradorNome}
                            onChange={handleChangeRes}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Data</label>
                        <input
                            type="date"
                            className="form-control"
                            name="dataReserva"
                            value={reservaSelecionada.dataReserva}
                            onChange={handleChangeRes}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Hora Início</label>
                        <input
                            type="time"
                            className="form-control"
                            name="horaInicio"
                            value={reservaSelecionada.horaInicio}
                            onChange={handleChangeRes}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Horário Final</label>
                        <input
                            type="time"
                            className="form-control"
                            name="horarioFinal"
                            value={reservaSelecionada.horarioFinal}
                            onChange={handleChangeRes}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Sala</label>
                        <select
                            className="form-select"
                            name="salaId"
                            value={reservaSelecionada.salaId}
                            onChange={(e) => {
                                const selectedSala = salasStatus.find(s => s.salaId === parseInt(e.target.value));
                                if (selectedSala?.statusSala) {
                                    handleChangeRes(e);
                                }
                            }}
                        >
                            <option value="">Selecione a sala</option>
                            {salasStatus.map(sala => (
                                <option
                                    key={sala.salaId}
                                    value={sala.salaId}
                                    disabled={!sala.statusSala}
                                    style={!sala.statusSala ? { color: '#6c757d' } : {}}
                                >
                                    Sala do {sala.nomeSala}{!sala.statusSala && " (Indisponível)"}
                                </option>
                            ))}
                        </select>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={ReservaPost}>Salvar</Button>
                    <Button color="danger" onClick={fecharModal}>Cancelar</Button>
                </ModalFooter>
            </Modal>

            {/* Modal de Exclusão (mantido original) */}
            <Modal isOpen={modalExcluirAberto} toggle={fecharModalExcluir}>
                <ModalHeader toggle={fecharModalExcluir}>Solicitar Exclusão de Reserva</ModalHeader>
                <ModalBody>
                    <p><strong>Reserva de:</strong> {reservaParaExcluir?.colaboradorNome}</p>
                    <p><strong>Data:</strong> {reservaParaExcluir?.dataReserva}</p>
                    <p><strong>Horário:</strong> {reservaParaExcluir?.horaInicio} - {reservaParaExcluir?.horarioFinal}</p>
                    <p><strong>Sala:</strong> {reservaParaExcluir?.salaId}</p>

                    <div className="form-group">
                        <label>Motivo da Exclusão</label>
                        <textarea className="form-control" value={motivoExclusao} onChange={e => setMotivoExclusao(e.target.value)} />
                    </div>
                    <div className="form-group mt-2">
                        <label>Email do Solicitante</label>
                        <input type="email" className="form-control" value={emailSolicitante} onChange={e => setEmailSolicitante(e.target.value)} />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={solicitarExclusao}>Enviar Solicitação</Button>
                    <Button color="secondary" onClick={fecharModalExcluir}>Cancelar</Button>
                </ModalFooter>
            </Modal>

            <footer className="footer">
                {/* ... (mantido o footer original) ... */}
            </footer>
        </div>
    );
}